import React, { useEffect, useState } from "react";
import { TextInput } from "@mantine/core";

const NUMERIC = /^\d+$/;

// Renders a label followed by an inline-editable ID field for use inside a
// page subheader title (see setSubheaderText in navigateActions.js). The
// field commits on Enter/blur, and reverts to `value` if the entry is blank,
// unchanged, or fails `validate`.
const EditableIdSubheaderTitle = ({
	label,
	value,
	onCommit,
	validate = (v) => NUMERIC.test(v),
}) => {
	const [inputValue, setInputValue] = useState(String(value ?? ""));

	useEffect(() => {
		setInputValue(String(value ?? ""));
	}, [value]);

	const commit = () => {
		const trimmed = inputValue.trim();
		if (trimmed && trimmed !== String(value) && validate(trimmed)) {
			onCommit(trimmed);
		} else {
			setInputValue(String(value ?? ""));
		}
	};

	return (
		<span
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: 6,
				verticalAlign: "middle",
			}}
		>
			{label ? <span>{label}</span> : null}
			<TextInput
				size="md"
				placeholder="ID"
				value={inputValue}
				onChange={(event) => setInputValue(event.currentTarget.value)}
				onBlur={commit}
				onKeyDown={(event) => {
					if (event.key === "Enter") {
						event.preventDefault();
						commit();
					} else if (event.key === "Escape") {
						setInputValue(String(value ?? ""));
					}
				}}
				styles={{
					input: {
						height: 36,
						minHeight: 36,
						width: 140,
						fontFamily: "monospace",
						fontSize: 16,
						paddingLeft: 6,
						paddingRight: 6,
					},
				}}
			/>
		</span>
	);
};

export default EditableIdSubheaderTitle;
